import "./Footer.css";

const Footer = () => {
    return (
        <footer>
            <div className="Facebook"></div>
            <div className="Instagram"></div>
        </footer>
    );
}

export default Footer; 